import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { AuthService } from '../../../auth/auth.service';

function parsePositiveInt(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value;
  }
  if (typeof value === 'string' && value.trim()) {
    const parsed = parseInt(value.trim(), 10);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed;
    }
  }
  return null;
}

/** Resolve organization id for event form data sources (form values, params, then auth). */
export function resolveEventFormOrganizationId(
  params?: LoadDataParams,
  auth?: AuthService
): number | null {
  const qp = (params?.queryParams ?? {}) as Record<string, unknown>;
  const candidates: unknown[] = [
    params?.organizationId,
    qp['organizationId'],
    qp['organization_id'],
    qp['organizations_id'],
    qp['organization'] && typeof qp['organization'] === 'object'
      ? (qp['organization'] as Record<string, unknown>)['id']
      : null,
  ];

  for (const filter of params?.filters ?? []) {
    if (!filter?.column) {
      continue;
    }
    const column = String(filter.column).toLowerCase();
    if (
      column === 'organizationid' ||
      column === 'organization_id' ||
      column === 'organizations_id'
    ) {
      candidates.push(filter.value);
    }
  }

  for (const candidate of candidates) {
    const parsed = parsePositiveInt(candidate);
    if (parsed != null) {
      return parsed;
    }
  }

  if (!auth) {
    return null;
  }

  const user = auth.getCurrentUser() as Record<string, unknown> | null;
  const fromUser =
    user?.['organizations_id'] ??
    (user?.['user_info'] as Record<string, unknown> | undefined)?.['organizations_id'];
  return parsePositiveInt(fromUser);
}
